import type { IVariable } from "@bbj-types/utils";
import { Box, Stack, type Theme, Typography, useMediaQuery } from "@mui/material";
import { EditorV2 } from "@styleguide";
import { type Control, Controller } from "react-hook-form";
import type { TEmailForm } from "./resolver";

interface IObjectInputProps {
  control: Control<TEmailForm, void>;
  variables: IVariable[];
}
export const ObjectInput = ({ control, variables }: IObjectInputProps) => {
  const tablet = useMediaQuery((theme: Theme) => theme.breakpoints.up("tablet"));

  return (
    <Stack
      direction={tablet ? "row" : "column"}
      sx={{
        gap: tablet ? 0 : 1,
        alignItems: tablet ? "center" : "start",
      }}
    >
      <Typography
        sx={{
          minWidth: "7%",
        }}
      >
        Objet * :
      </Typography>
      <Box sx={{ flex: 1, width: tablet ? "auto" : "100%" }}>
        <Controller
          control={control}
          name="subject"
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Box
              sx={{
                "& .tox-editor-header": { position: "absolute", right: 0 },
              }}
            >
              <EditorV2
                toolbar="variable"
                onChange={(_, text) => onChange(text)}
                value={value}
                variableList={variables}
                excludePlugins={["autoresize"]}
                init={{
                  height: 39,
                  min_height: 0,
                }}
              />
              {error?.message && (
                <Typography variant="caption" sx={{ color: "error.main", display: "block", mt: 0.5 }}>
                  {error.message}
                </Typography>
              )}
            </Box>
          )}
        />
      </Box>
    </Stack>
  );
};
